import {useMemo} from 'react'
import {useLocation, useParams} from 'react-router'

function convertToNumber(str: string): number | null {
  const parsedNumber = parseInt(str, 10)

  if (isNaN(parsedNumber)) {
    return null
  }

  return parsedNumber
}

export function useNumFromUrlParamKey(key: string): number | null {
  const params = useParams() as Record<string, string>
  const param = params[key]
  return param !== undefined ? convertToNumber(param) : null
}

function useQuery(): URLSearchParams {
  const {search} = useLocation()
  return useMemo(() => new URLSearchParams(search), [search])
}

export function useQueryParamAsString(key: string): string | null {
  const query = useQuery()
  return query.get(key)
}

export function useQueryParamAsNum(key: string): number | null {
  const query = useQuery()
  const queryValue = query.get(key)
  return queryValue !== null ? convertToNumber(queryValue) : null
}
